export const API_REQUEST_SENT = '@@apiRequest/sent'
export const API_REQUEST_CANCEL = '@@apiRequest/cancel'
export const API_REQUEST_FAILED = '@@apiRequest/failed'
export const API_REQUEST_DONE = '@@apiRequest/done'

export const API_REQUEST_CLEAR = '@@apiRequest/clear'
